export default __webpack_public_path__ + "static/media/seven.202dba65.png";